import { render, staticRenderFns } from "./EmailAccounts.vue?vue&type=template&id=3ffa5799"
import script from "./EmailAccounts.vue?vue&type=script&lang=js"
export * from "./EmailAccounts.vue?vue&type=script&lang=js"
import style0 from "./EmailAccounts.vue?vue&type=style&index=0&id=3ffa5799&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports